import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { IconButton, InputAdornment, TextField } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'

import MuiButton from '../MuiComponents/MuiButton'
import './Login.scss'
import { IState } from '@root-gipro/store/interfaces'
import { login as loginAction } from '@root-gipro/store/actions' // 👈 импорт login action

const Login: React.FC = () => {
	const dispatch = useDispatch()

	const [login, setLogin] = useState('')
	const [password, setPassword] = useState('')
	const [showPassword, setShowPassword] = useState(false)

	const handleClickShowPassword = () => setShowPassword(prev => !prev)
	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault() // предотвращает фокус на кнопке
	}

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		if (login && password) {
			dispatch(loginAction(login, password))
		}
	}

	return (
		<div className='login'>
			<a href='https://gipro.su/gipro-unc' target='_blank' rel='noopener noreferrer'>
				<img className='login__image' src='/assets/images/svg/logo1.svg' alt='Логотип' />
			</a>

			<form className='login__form' onSubmit={handleSubmit} autoComplete='on'>
				<h2 className='login__title'>Логин</h2>

				<div className='login__fields'>
					<TextField
						label='Email'
						variant='outlined'
						fullWidth
						type='email'
						name='email'
						autoFocus
						value={login}
						onChange={e => setLogin(e.currentTarget.value)}
						inputProps={{ inputMode: 'email' }}
					/>

					<TextField
						label='Пароль'
						variant='outlined'
						fullWidth
						type={showPassword ? 'text' : 'password'}
						name='password'
						value={password}
						onChange={e => setPassword(e.currentTarget.value)}
						InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
									<IconButton
										size='small'
										aria-label='показать/скрыть пароль'
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</div>

				<div className='login__actions'>
					<MuiButton fullWidth variant='contained' color='primary' type='submit'>
						Войти в систему
					</MuiButton>

					{/* <Link to='/recall' className='login__actions-item link-blue'>Забыли пароль?</Link> */}
				</div>
			</form>
		</div>
	)
}

export default Login
